






































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import Tab from './tabs/Tab.vue';
import Tabs from './tabs/Tabs.vue';
import FileUpload from 'vue-upload-component';

@Component({
    components: { FileUpload, Tabs, Tab },
})
export default class AddImage extends Vue {
    private imageDesc = '';

    private imageUrl = 'https://www.datafountain.cn/favicon.ico';

    private files = [];

    @Prop({ type: [Function] })
    private addExistImage: Function;

    private mounted() {
        // 适配首页

        if ((this.$route.query as any).df_website) {
            const dom = document.querySelector('.editormd');

            const modal:any = document.querySelector('.v--modal-box');

            setTimeout(() => {
                modal.style['top'] = dom.getBoundingClientRect().top + 35 + 'px';
            });
        }
    }

    private handleCancel() {
        this.$emit('close');
    }

    private handleExistsImage() {
        if (this.addExistImage) {
            this.addExistImage(this.imageUrl, this.imageDesc);
        }

        this.$emit('close');
    }

    private handleUploadedImage() {
        document.querySelector('#modals-container').innerHTML = '';
    }

    /**

     * Has changed

     * @param  Object|undefined   newFile   只读

     * @param  Object|undefined   oldFile   只读

     * @return undefined

     */

    private inputFile(newFile, oldFile) {
        if (newFile && !newFile.active) {
            (this.$refs.upload as any).active = true;
        }

        if (newFile && oldFile && !newFile.active && oldFile.active) {
            // 获得相应数据

            // console.log('response', newFile.response)

            if (newFile.xhr) {
                //  获得响应状态码
                // console.log('status', newFile.xhr.status)
            }

            // Automatically activate upload

            if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
                (this.$refs.upload as any).active = true;
            }
        }
    }

    /**

     * Pretreatment

     * @param  Object|undefined   newFile   读写

     * @param  Object|undefined   oldFile   只读

     * @param  Function           prevent   阻止回调

     * @return undefined

     */

    private inputFilter(newFile, oldFile, prevent) {
        if (newFile && !oldFile) {
            // 过滤不是图片后缀的文件

            if (!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
                return prevent();
            }
        }

        // 创建 blob 字段 用于图片预览

        newFile.blob = '';

        const URL = (window as any).URL || (window as any).webkitURL;

        if (URL && URL.createObjectURL) {
            newFile.blob = URL.createObjectURL(newFile.file);
        }
    }
}
